import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ErrCode, User } from '../../models';
import { LoggerService } from 'src/app/core/logger.service';
import { UserService } from 'src/app/core/user.service';
import { PasswordService } from 'src/app/auth/services/password.service';

@Component({
  selector: 'app-dialog-confirm-password',
  templateUrl: './dialog-confirm-password.component.html',
  styleUrls: ['./dialog-confirm-password.component.scss']
})
export class DialogConfirmPasswordComponent implements OnInit {
  @Input() showDialog: boolean = false;
  @Output() showDialogChange = new EventEmitter<boolean>();
  @Output() action = new EventEmitter<void>();

  public isLoading: boolean = false;
  public errcode: ErrCode;
  private user: User = undefined;
  public password: string;

  constructor(
    private log: LoggerService,
    private passwordService: PasswordService,
    private userService: UserService
  ) { }

  ngOnInit() {
    this.user = this.userService.getUser();
  }

  public setPassword = (password: string) => {
    this.password = password;
  }

  public checkPassword = async () => {
    this.isLoading = true;
        try {
            await this.passwordService.passwordValid(this.user.email, this.password);
            this.isLoading = false;
            this.log.info('Password is valid, continue');
            this.closeDialog();
            this.action.emit();
        } catch (ex) {
            this.isLoading = false;
            if (ex instanceof ErrCode) {
                if (ex.code == 8101) {
                    // password incorrect
                    this.log.warn(`${ex.code} - user entered incorrect`);
                }
                this.errcode = ex;
            } else if (ex instanceof Error) {
                this.log.error(ex.toString());
                this.errcode = new ErrCode(1000, ex.toString());
            } else {
                this.log.error(ex.toString());
                this.log.error(ex);
                this.log.error('DialogConfirmPassword encountered unhandled error');
                this.errcode = new ErrCode(1000, 'An unknown error occcured');
            }
        }
  }

  public closeDialog = () => {
    this.showDialog = false;
    setTimeout(() => {
      this.showDialogChange.next(false);
    });
  }
}
